export default "__VITE_ASSET__BVsQdk$a__"